module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/picture_2-586a44241a481ec75e137d2234df780a.png";